<template>
  <div class="app bg-gray" id="register-departDoctor">
    <!-- 医院标题 -->
    <section class="thick" style="margin-bottom: 0px">
      <div class="hospital-logo-line">
        <span class="logo-img"></span>
        <span class="logo-title" id="register-hospital-title">{{
          hospitalName
        }}</span>
      </div>
    </section>
    <div class="top-tips" @click="showStopAdmissionView()">
      点击查看停诊消息
    </div>
    <!-- tab标签 -->
    <section class="thick">
      <ul class="tab-top">
        <li
          @click="onSelectedTab(item)"
          v-for="item in tabs"
          class="tab-item"
          :id="'register-departDoctor-tab-' + item.tabId"
          :class="{ active: selectedTab.tabId == item.tabId }"
        >
          <span class="tab-label">{{ item.tabName }}</span>
        </li>
      </ul>
    </section>
    <!-- 搜索栏 -->
    <section
      @click="openSearch()"
      class="thick"
      style="padding: 0.3rem"
      id="register-departDoctor-search"
    >
      <div class="search-line">
        <span class="search-img"></span>
        <span class="search-hint">{{ selectedTab.searchText }}</span>
      </div>
    </section>
    <popup class="popup-search bg-gray" v-model="isActive" :self-close="true">
      <section
        class="flex-row flex-align-center bg-white"
        style="padding: 0.3rem"
      >
        <input
          id="register-departDoctor-search-input"
          class="search-input flex-item flex-width"
          :placeholder="selectedTab.searchText"
          maxlength="20"
          v-model="searchKeyWord"
        />
        <span
          id="register-departDoctor-search-btn"
          class="search-btn"
          @click="doSearch()"
        ></span>
      </section>
      <scroll style="top: 2rem">
        <div
          id="register-departDoctor-search-norecord"
          v-show="hasSearched & (searchList.length === 0)"
          class="search-noDate-pic"
        >
          <p class="search-noDate-text">抱歉，暂未找到符合条件的结果</p>
          <p class="search-noDate-tips">试试换个关键词吧~</p>
        </div>
        <ul
          v-show="!selectedTab.tabId"
          class="list"
          id="register-departDoctor-search-departList"
        >
          <li
            class="list-item arr-item"
            v-for="(searchItem, index) in searchList"
            @click="onSearchItemSelected(searchItem)"
            :id="'register-departDoctor-search-departList-' + index"
          >
            <span>{{ searchItem.deptName }}</span>
          </li>
        </ul>
        <ul
          v-show="selectedTab.tabId"
          class=""
          id="register-departDoctor-search-doctList"
        >
          <li
            class="arr-row"
            v-for="(searchItem, index) of searchList"
            @click="onSearchItemSelected(searchItem)"
            :id="'register-departDoctor-search-doctList-' + index"
          >
            <div class="doctor-info">
              <div class="head doc-header"></div>
              <div class="info">
                <p class="f-large ellipsis">
                  {{ searchItem.doctLevel }}&nbsp;{{ searchItem.doctName }}
                </p>
                <p class="f-strong ellipsis" style="margin-top: 0.15rem">
                  {{ searchItem.deptName }}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </scroll>
    </popup>

    <!-- 科室列表/医生列表 -->
    <scroll @refresh="refresh" style="top: 5.7rem">
      <depart-list
        :selectedTab="selectedTab"
        :selectedArea="selectedArea"
        :departs="departs"
      ></depart-list>
      <doctor-list
        :selectedTab="selectedTab"
        :selectedArea="selectedArea"
        :doctors="doctors"
      ></doctor-list>
    </scroll>
    <stop-admission v-model="showStopAdmission" :data-list="confirmList">
      <span slot="title" style="color: white">温馨提示</span>
      <ul slot="list" class="list">
        <li v-for="(item, index) in confirmList" class="list-item">
          <span>{{ index + 1 }}. {{ item.time }} {{ item.content }}</span>
        </li>
      </ul>
    </stop-admission>
  </div>
</template>
<script>
import DepartList from './DepartList';
import DoctorList from './DoctorList';
import registerService from 'register.service';
import NoRecord from 'NoRecord';
import StopAdmission from "ConfirmListBox";

export default {
  components: {
    DepartList,
    DoctorList,
    NoRecord,
    StopAdmission
  },
  mounted () {
    this.$store.commit('clearParam', 'register');
    this.refresh();
  },
  data () {
    return {
      confirmList: [],
      showStopAdmission: false,
      hospitalName: "",
      tabs: [{ 'tabId': 0, 'tabName': '按科室', 'searchText': '输入二级科室', 'noRecordText': '查找不到科室，请重新输入' },
      { 'tabId': 1, 'tabName': '按医生', 'searchText': '输入医生姓名', 'noRecordText': '查找不到医生，请重新输入' }],
      selectedTab: { 'tabId': 0, 'tabName': '按科室', 'searchText': '输入科室姓名', 'noRecordText': '查找不到科室，请重新输入' },
      // 科室列表数据
      areas: [],
      selectedArea: { 'areaId': '1', 'areaName': '总院' },
      departs: [],
      allSubDeparts: [],
      // 医生列表数据
      doctors: [],
      instuteCode: 102,
      searchKeyWord: "",
      searchList: [],
      hasSearched: false,
      isActive: false
    };
  },
  computed: {},
  methods: {
    refresh: function () {
      this.loadStopAdmissionList()
    },
    loadStopAdmissionList () {
      registerService.loadStopAdmission().then((res) => {
        const selectHospital = localStorage.selectedHospital;
        this.hospitalName = selectHospital ? JSON.parse(selectHospital).hospitalName : "";
        const tabId = window.localStorage.tabId;
        const firstSelectTab = tabId === "1" ? this.tabs[1] : this.tabs[0];
        this.onSelectedTab(firstSelectTab);
        window.localStorage.tabId = "";

        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        this.confirmList = res.data || [];
        if (this.confirmList.length > 0) {
          //判断是否推送过的消息
          if (localStorage.stopAdmissionList && this.checkArrayDatas(JSON.parse(localStorage.stopAdmissionList), this.confirmList)) {
            return
          }
          this.showStopAdmission = true;
          localStorage.stopAdmissionList = JSON.stringify(this.confirmList);
        }
      });
    },
    loadDepart: function () {
      registerService.loadDepart({ areaId: this.selectedArea.areaId }).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }

        this.departs = res.data || [];
        if (this.departs.length > 0) {
          this.departs.forEach((item) => {
            this.allSubDeparts = this.allSubDeparts.concat(item["children"]);
          });
        } else {
          this.allSubDeparts = [];
        }
      });
    },
    loadDoctor: function () {
      registerService.loadDoctor({ instuteCode: this.instuteCode }).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        const items = res.data || []
        if (items.length > 0) {
          for (let i = 0; i < items.length; i++) {
            items[i].showDetailRemain = false
            items[i].hasMoreRemain = true
          }
        }
        this.doctors = items
      });
    },
    onSelectedTab: function (item) {
      this.selectedTab = item;
      // 数据加载
      if (this.selectedTab.tabId) {
        this.doctors.length === 0 && this.loadDoctor();
      } else {
        this.departs.length === 0 && this.loadDepart();
      }
    },
    openSearch: function () {
      this.searchList = [];
      this.searchKeyWord = "";
      this.isActive = true;
      this.hasSearched = false;
    },
    closeSearch: function () {
      this.isActive = false;
    },
    doSearch: function () {
      this.hasSearched = true;
      this.searchList = [];
      const searchKey = this.searchKeyWord.trim();
      if (searchKey.length === 0) {
        return;
      }
      if (!this.selectedTab.tabId) {
        this.allSubDeparts.forEach((item) => {
          this.findDepart(searchKey, item) && this.searchList.push(item);
        });
      } else {
        this.doctors.forEach((item) => {
          this.findDoctor(searchKey, item) && this.searchList.push(item);
        });
      }
    },
    findDepart: function (key, subDepart) {
      return subDepart.deptName.indexOf(key) > -1 ? true : false;
    },
    findDoctor: function (key, doctor) {
      return doctor.doctName.indexOf(key) > -1 ? true : false;
    },
    onSearchItemSelected: function (item) {
      if (this.selectedTab.tabId) {
        this.onSelectedDoctor(item);
      } else {
        this.onSelectedSubDepart(item);
      }
    },
    onSelectedDoctor: function (item) {
      this.$store.commit('updateParam', {
        namespace: 'register',
        doc: item,
        area: this.selectedArea
      })
      window.localStorage.tabId = "1";
      this.$router.push('DateTimeSchedule');
    },
    onSelectedSubDepart: function (item) {
      this.$store.commit('updateParam', {
        namespace: 'register',
        depart: item,
        area: this.selectedArea
      })
      window.localStorage.tabId = "0";
      this.$router.push('DateDoctorSchedule');
    },
    showStopAdmissionView: function () {
      if (this.confirmList.length === 0) {
        this.$utils.alert('暂无停诊信息');
        return
      }
      this.showStopAdmission = true
    },
    checkArrayDatas: function (arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false
      }

      //强关联后台数据及顺序
      for (var i = 0; i < arr1.length; i++) {
        if (arr1[i].id !== arr2[i].id) {
          return false
        }
      }
      return true
    }
  }
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";

.search-line {
  height: 1rem;
  width: 100%;
  background: #f0f2f4;
  color: #333333;
  text-align: center;
  font-size: 0.65rem;
  border: 1px solid #c8cbce;
  .search-img {
    background-image: url(../../../static/img/seach-gray-icon.png);
    height: 0.45rem;
    width: 0.45rem;
    margin-right: 0.25rem;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;
  }
  .search-hint {
    display: inline-block;
    vertical-align: middle;
  }
}

.search-input {
  height: 1rem;
  line-height: 1rem;
  background: $common-bg-color;
  color: $main-gray;
  font-size: 0.45rem;
  padding-left: 0.25rem;
  border: none;
}

.search-btn {
  width: 1.2rem;
  height: 1rem;
  line-height: 1rem;
  margin-left: 0.25rem;
  background-color: $main-style-color;
  background-image: url(../../../static/img/seach-white-icon.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 0.6rem;
}

.search-noDate-pic {
  background: url(../../../static/img/sousuo-bg.png) no-repeat top center;
  background-size: 111px 111px;
  margin: 3rem auto 0 auto;
  width: 100%;
}

.search-noDate-text {
  font-size: 18px;
  text-align: center;
  height: 2rem;
  line-height: 2rem;
  padding-top: 3rem;
}

.search-noDate-tips {
  font-size: 13px;
  text-align: center;
  color: $main-gray;
}

.popup-search {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  text-align: left;
  color: #444;
  z-index: 4;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// DepartDoctor.vue?469c1501